import { Loader as Loaderr } from "lucide-react"



export const Loader=()=>{
    return <Loaderr size={15} className="animate-spin" />
}